import React, {Component} from 'react';
import renderHTML from 'react-render-html';
import { bindActionCreators, compose } from "redux"
import {connect} from 'react-redux';
import * as Actions from '../actions/index';

import Article from './main/article';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';
import MenuButton from './menuButton';

class Menu extends Component {
	
	render() {
		return(
			<div className="category-nav-wrapper">
			{
				this.props.cat.children.map( (kid, index) => {
					var thisIndex = index+1 ;
					return ( <MenuButton active={ thisIndex === this.props.selectedCat.category } key={thisIndex} id={thisIndex} catID={kid.term_id} name={kid.name} /> );
				})
			}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		cat: state.cat,
		selectedCat: state.selectedCat
	};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/menu.js